import React from 'react';
import { Text } from '@carnica/ui-kit';
import { cnBem, getMessageText } from "../../../../shared/lib";
import { withMessageWrapper } from "../../lib";
import styles from "./styles.pcss";
import { DateBlock } from "../DateBlock";
var cnMessageText = cnBem('message-text', styles);
var TextViewRender = function TextViewRender(props) {
  var className = props.className,
    message = props.message,
    side = props.side,
    stage = props.stage;
  return /*#__PURE__*/React.createElement("p", {
    className: cnMessageText({
      side: side
    }, [className])
  }, /*#__PURE__*/React.createElement(Text, {
    className: cnMessageText('text'),
    color: side === 'main' ? 'primary' : 'primary-invert',
    "data-is-text": true,
    tagName: "span",
    variant: "body-small"
  }, getMessageText(message)), /*#__PURE__*/React.createElement(DateBlock, {
    date: message.date,
    side: side,
    stage: stage,
    view: "inside"
  }));
};
export var TextView = withMessageWrapper({
  bordered: function bordered(side) {
    return side === 'opposite';
  },
  withDate: false
})(TextViewRender);